export default __webpack_public_path__ + "static/media/avatar1.2f1a73f2.png";